{
  "movement": {
    "loader": "Loader",
    "digger": "Digger",
    "movementFrom": "Movement From",
    "movementTo": "Movement To",
    "plantModel": "Plant Model",
    "ownLoad": "Own load",
    "live": "Live",
    "selectLoader": "Please select a Loader",
    "selectDigger": "Please select a Digger",
    "selectPlantModel": "Please select a Plant Model",
    "selectTruck": "Please select a Truck",
    "selectHour": "Please select an Hour",
    "selectTime": "Please select a Time",
    "selectFrom": "Please select a location to move from",
    "enterLoads": "Please enter the number of loads to move",
    "selectTo": "Please select a location to move to",
    "selectDifferentTo": "Please select a different location to move to",
    "acceptUnreachable": "Could not reach the server; the row was not accepted",
    "rowAccepted": "Row accepted",
    "nothingToCheck": "Nothing needed checking on this shift",
    "rowsAccepted_one": "{{count}} row accepted",
    "rowsAccepted_other": "{{count}} rows accepted",
    "showingGroups": "Showing groups",
    "groupMovements": "Group movements",
    "telemetryNote": "Rows the telemetry recorded arrive marked \"Needs checking\".",
    "acceptAll": "Accept All"
  },
  "totals": {
    "loads": "Total Loads:",
    "tonnes": "Total Tonnes:",
    "tbc": "TBC"
  },
  "crushing": {
    "title": "Crushing",
    "selectCrushingSite": "Please select a Crushing site to move to",
    "updated": "Crushing Entry updated successfully",
    "added": "Crushing Entry added successfully",
    "deleted": "Crushing entry deleted successfully",
    "verifySubject": "crushing row",
    "empty": "No crushing entries during selected shift.",
    "entity": "a new crushing entry",
    "howToAdd": "Add a new one by selecting a <b>loader</b>, <b>movement origin</b>, <b>number of loads</b> and <b>destination</b> above.",
    "acceptAllConfirm": "Mark every unchecked crushing row on this shift as checked?"
  },
  "rehandle": {
    "title": "Rehandle",
    "updated": "Rehandle Entry updated successfully",
    "added": "Rehandle Entry added successfully",
    "deleted": "Ore Rehandle entry deleted successfully",
    "verifySubject": "rehandle row",
    "empty": "No rehandle entries during selected shift.",
    "entity": "a new rehandle entry",
    "howToAdd": "Add a new one by selecting a <b>digger</b>, <b>plant model</b>, <b>movement origin</b>, <b>number of loads</b> and <b>destination</b> above.",
    "acceptAllConfirm": "Mark every unchecked rehandle row on this shift as checked?"
  },
  "groups": {
    "confidence": "Confidence",
    "checked": "Checked",
    "movements": "Movements",
    "manual": "Manual",
    "auto": "Auto",
    "mixed": "Mixed {{auto}}/{{total}}",
    "verifySubject": "group",
    "accepted_one": "Accepted {{count}} row",
    "accepted_other": "Accepted {{count}} rows",
    "deleted_one": "Deleted {{count}} row",
    "deleted_other": "Deleted {{count}} rows",
    "deleteConfirm_one": "Delete all {{count}} movement in this group?",
    "deleteConfirm_other": "Delete all {{count}} movements in this group?"
  },
  "errors": {
    "tryAgain": "There was an error, please try again"
  },
  "filters": {
    "from": "From: ",
    "to": "To: ",
    "selectFromDate": "Select from date",
    "selectToDate": "Select to date"
  },
  "drilling": {
    "title": "Geology Drilling",
    "dateRequired": "Date is required",
    "added": "Entry added successfully",
    "updated": "Drilling entry updated successfully",
    "deleted": "Drilling entry deleted successfully",
    "gcLocation": "GC Location",
    "gcHoles": "GC Holes",
    "gcMetres": "GC metres",
    "rcLocation": "RC Location",
    "rcHoles": "RC Holes",
    "rcMetres": "RC metres",
    "rabLocation": "RAB Location",
    "rabHoles": "RAB Holes",
    "rabMetres": "RAB metres",
    "holes": "Holes",
    "metres": "Metres"
  },
  "milling": {
    "title": "Milling",
    "allMills": "All Mills",
    "millNumber": "Mill {{number}}",
    "mill": "Mill",
    "selectDate": "Please select a date",
    "selectMill": "Please select a mill",
    "enterWetTonnes": "Please enter wet tonnes milled",
    "enterMoisture": "Please enter moisture percentage",
    "moistureRange": "Please enter moisture percentage between 0 and 100",
    "enterDryTonnes": "Please enter dry tonnes milled",
    "enterLeachFeedGradeAu": "Please enter leach feed grade of Au",
    "enterLeachFeedGradeAg": "Please enter leach feed grade of Ag",
    "enterAuFeedOunces": "Please enter Au feed ounces",
    "enterAuOzRecovered": "Please enter Au ounces recovered",
    "enterAgFeedOunces": "Please enter Ag feed ounces",
    "added": "Milling Entry added successfully",
    "deleted": "Milling entry deleted successfully",
    "updated": "Milling entry updated successfully",
    "wetTonnesMilled": "Wet Tonnes Milled (t)",
    "moisture": "Moisture (%)",
    "dryTonnesMilled": "Dry Tonnes Milled (t)",
    "leachFeedGradeAu": "Leach Feed grade Au (g/t)",
    "leachFeedGradeAg": "Leach Feed grade Ag (g/t)",
    "auFeedOunces": "Au Feed Ounces",
    "auOzRecovered": "Au Oz Recovered",
    "agFeedOunces": "Ag Feed Ounces"
  },
  "pickers": {
    "selectMaterialTypeClass": "Select Material Type Class",
    "selectStage": "Select Stage"
  },
  "oreBlocks": {
    "title": "Ore Blocks",
    "nameRequired": "Ore Block name cannot be empty",
    "selectMaterialType": "Please select a material type",
    "selectPhase": "Please select a phase",
    "benchRequired": "Bench cannot be empty",
    "gradesPositive": "Analyte grades must be greater than 0",
    "flitchRequired": "Flitch cannot be empty",
    "estimatedTonnesRequired": "Estimated Tonnes cannot be empty",
    "densityRequired": "Density cannot be empty",
    "added": "Ore Block added successfully",
    "updated": "Ore Block updated successfully",
    "deleted": "Ore Block deleted successfully",
    "stage": "Stage",
    "completed": "Completed",
    "bench": "Bench",
    "flitch": "Flitch",
    "estimatedTonnes": "Estimated Tonnes",
    "tonnesRemaining": "Tonnes Remaining",
    "geofence": "Geofence",
    "polygon": "Polygon",
    "setGeofence": "Set",
    "filter": "Filter",
    "includeCompleted": "Include Completed",
    "geofenceSaved": "Geofence saved",
    "geofenceTitle": "Dig block geofence - {{oreBlock}}",
    "excav": "Excav",
    "dayShift": "Day ☀️",
    "nightShift": "Night 🌙",
    "model": "Model"
  },
  "columns": {
    "density": "Density",
    "bcm": "BCM",
    "pit": "Pit",
    "blastmaster": "Blastmaster",
    "truckModel": "Truck Model",
    "excavator": "Excavator"
  },
  "oreTally": {
    "title": "Tally",
    "provenanceManual": "Manual",
    "provenanceGps": "GPS",
    "provenanceMixed": "Mixed",
    "manage": "Manage",
    "tally": "Tally",
    "pitControl": "Pit Control",
    "sourceLine": "Tally: {{tally}} · Pit Control: {{pitControl}}",
    "noIndependentCheck": "No independent check",
    "onlyOneSide": "Only one side counted",
    "entryUpdated": "An entry has been updated",
    "noResults": "No results for this search.",
    "managePitControl": "To manage <b>Pit Control</b>, go to<page>Production<icon/></page>",
    "manageOreTally": "To manage <b>Ore Tally</b>, go to<page>Geology<icon/></page>",
    "totalTallyLoads": "Total Tally Loads:",
    "totalPitControlLoads": "Total Pit Control Loads:",
    "includeWaste": "Include Waste",
    "oreTallyLoads": "Ore Tally Loads:",
    "pitControlLoads": "Pit Control Loads:",
    "loadingUpdateFailed": "Failed to update loading entry",
    "loadingUpdated": "Loading entry updated successfully",
    "loadingDeleteFailed": "Failed to delete loading entry",
    "loadingDeleted": "Loading entry deleted successfully"
  },
  "shifts": {
    "day": "Day",
    "night": "Night",
    "both": "Both",
    "afternoon": "Afternoon"
  },
  "production": {
    "title": "Production",
    "invalidEntry": "An invalid entry was submitted, please try again",
    "truckModelRequired": "Truck Model is required",
    "loadsRequired": "Loads is required",
    "dilutionRequired": "Dilution is required",
    "oreBlockRequired": "Ore Block is required",
    "stockpileRequired": "Stockpile is required",
    "added": "Entry added successfully",
    "updated": "Entry updated successfully",
    "deleted": "Entry deleted successfully",
    "block": "Block",
    "dilution": "Dilution %",
    "stockpileCrusher": "Stockpile/Crusher",
    "selectMachine": "Select a Machine",
    "selectPitStage": "Select a Pit Stage",
    "empty": "No production entries found.",
    "entity": "a new production entry",
    "howToAdd": "Add a new one by filling the information above.",
    "crusherLegend": "Crusher",
    "deleteEntry": "Delete entry",
    "stockpile": "Stockpile",
    "provideFilter": "Provide a filter",
    "noBlocks": "No blocks for provided Pit Stage and filters",
    "filterLabel": "Enter filter (flitch / block)",
    "commentSaved": "Entry saved successfully",
    "selectMachineAndStage": "Please select a machine and pit stage",
    "filterDeleted": "Filter deleted successfully",
    "chooseMachine": "Choose a Machine",
    "addComment": "Add a Comment",
    "noMovement": "No Movement Selected",
    "filterEmpty": "Filter cannot be empty",
    "filterExists": "That filter already exists",
    "commaFilter": "\",\" character cannot be used to filter",
    "addFilter": "Add Filter"
  },
  "summary": {
    "unableToNavigate": "Unable to navigate to the entry",
    "empty": "No production entries during selected shift.",
    "manageOnGeology": "You can manage production entries on the<page>Geology<icon/></page>page."
  },
  "recalc": {
    "title": "Confirm Recalculation",
    "body": "Recalculate stockpile balances from {{date}}?",
    "success": "Stockpile balances recalculated successfully"
  },
  "stockpiles": {
    "title": "Stockpile Balances",
    "stockpileName": "Stockpile Name",
    "balanceOpen": "Open",
    "balanceClose": "Close",
    "mining": "Mining",
    "rehandle": "Rehandle",
    "crush": "Crush",
    "tabHistory": "History",
    "tabMovement": "Movement",
    "tabRehandleCrusher": "Rehandle & Crusher",
    "tabAdjustments": "Adjustments",
    "notes": "Notes",
    "addedBy": "Added By",
    "stockpileFrom": "Stockpile From",
    "stockpileTo": "Stockpile To",
    "inbound": "Inbound",
    "outbound": "Outbound",
    "errorOccurred": "An error has occurred",
    "adjustmentApplied": "Adjustment applied successfully",
    "adjustmentAppliedToBlocks": "Adjustment applied to ore blocks",
    "adjDate": "Adj Date",
    "currentBalance": "Current Balance",
    "monthMovement": "Mvt to Stockpile for the month",
    "adjustment": "Adjustment",
    "newBalance": "New Balance",
    "adjustmentNotes": "Adjustment Notes",
    "currentTonnes": "Current Tonnes",
    "newTonnes": "New Tonnes",
    "reattributeNote": "The difference in tonnage can be reattributed to the Ore Blocks which have been mined since the beginning of the month. Click \"apply\" to accept these changes too.",
    "applyAdjustment": "Apply Adjustment",
    "applyToOreBlocks": "Apply to Ore Blocks"
  }
}
